<div class="request-pay-later-page">
    <business-units-select-page-header></business-units-select-page-header>
    <div class="page-container container-fluid">
        <ng-container *ngIf="isLoading">
            <lsq-circle-loader></lsq-circle-loader>
        </ng-container>
        <ng-container *ngIf="!isLoading">
            <div class="row mx-0 request-pay-later-actions-header-wrapper">
                <div class="col pl-xl-0 request-payment-actions-header">
                    <div class="request-payment-actions-header-inner">
                        <div class="progress-bar-section">
                            <lsq-progress-bar
                                [value]="utilizedAmountPercentage"
                                [dangerAboveThreshold]="100"
                            >
                            </lsq-progress-bar>
                            <div class="progress-bar-amounts">
                                <pay-later-amount-cluster
                                    class="progress-bar-amount"
                                    [label]="utilizedI18n"
                                    [divideLine]="true"
                                    [greenCircleIcon]="true"
                                    [textAlign]="'left'"
                                >
                                    {{ utilizedAmount$ | async | notNull | lsqCurrency }}
                                </pay-later-amount-cluster>
                                <pay-later-amount-cluster
                                    class="progress-bar-amount"
                                    [label]="availableI18n"
                                    [divideLine]="true"
                                    [grayCircleIcon]="true"
                                    [textAlign]="'left'"
                                >
                                    {{ availableAmount$ | async | notNull | lsqCurrency }}
                                </pay-later-amount-cluster>
                                <pay-later-amount-cluster
                                    class="progress-bar-amount"
                                    [label]="facilityLimitI18n"
                                    [textAlign]="'left'"
                                >
                                    {{ facilityLimitAmount$ | async | notNull | lsqCurrency }}
                                </pay-later-amount-cluster>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 pr-xl-0 col-xl-4 request-payment-actions-header">
                    <div class="request-payment-actions-header-inner">
                        <div class="payment-data-section">
                            <div class="request-payment-amounts">
                                <pay-later-amount-cluster
                                    class="request-payment-amount"
                                    [label]="totalPaymentI18n"
                                    [topRowStyle]="{ paddingBottom: '1rem' }"
                                >
                                    {{
                                        totalSelectedAvailableAmount$
                                            | async
                                            | notNull
                                            | lsqCurrency
                                    }}
                                </pay-later-amount-cluster>
                            </div>
                            <div class="submit-section">
                                <label i18n class="submit-label"
                                    ><input
                                        type="checkbox"
                                        [(ngModel)]="agree"
                                        class="submit-checkbox"
                                        [disabled]="
                                            !(editInvoicesClaimIsOn$ | async) ||
                                            (disableConfirmationDetails() && !agree)
                                        "
                                    />{{ confirmationI18n }}</label
                                >
                                <lsq-button
                                    class="submit-text"
                                    [appearance]="'primary'"
                                    [disabled]="
                                        !(editInvoicesClaimIsOn$ | async) ||
                                        disableConfirmationDetails() ||
                                        !agree
                                    "
                                    [submitting]="submittingBatch"
                                    (buttonClick)="requestPayLater()"
                                >
                                    Submit Request
                                </lsq-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="cards-wrapper" *ngIf="!(responsiveService.mdBelow | async)">
                <div class="invoices-table-card-wrapper">
                    <card class="invoices-table-card">
                        <div left-header-content>
                            <div class="checkbox-controls">
                                <lsq-table-checkbox-controls
                                    [isFilteredSelectAll]="true"
                                    [checkableRowsService]="checkableRowsService"
                                    [disabled]="!(editInvoicesClaimIsOn$ | async)"
                                ></lsq-table-checkbox-controls>
                            </div>
                        </div>
                        <div right-header-content class="request-pay-later-header-right">
                            <lsq-button
                                class="clear-filters"
                                appearance="transparent"
                                size="sm"
                                (buttonClick)="clearFilters()"
                            >
                                <ng-container i18n>Clear filters</ng-container>
                            </lsq-button>
                            <div
                                class="invoice-number-search"
                                [formGroup]="searchInvoicesFormGroup"
                            >
                                <lsq-input
                                    #invoiceNumberSearch
                                    i18n-placeholder
                                    placeholder="Search"
                                    formControlName="invoiceNumberSearch"
                                    [name]="'invoiceNumberSearch'"
                                    [prependIcon]="[
                                        icons.FaMagnifyingGlassSolid,
                                        color.GraphicGray
                                    ]"
                                    [group]="searchInvoicesFormGroup"
                                >
                                </lsq-input>
                            </div>
                            <div class="payment-date" [formGroup]="dateFilterFormGroup">
                                <lsq-date-select
                                    id="dateFilter"
                                    [allowFuture]="true"
                                    [type]="datePickerType.Range"
                                    [sideBySide]="true"
                                    [group]="dateFilterFormGroup"
                                    formControlName="dateFilter"
                                    [label]="dateSelectLabel"
                                >
                                </lsq-date-select>
                            </div>
                            <div class="invoice-seller-keys" [formGroup]="sellersFormGroup">
                                <lsq-multi-select
                                    *ngIf="supplierFilterOptions$ | async"
                                    class="invoices-filters-suppliers-filter"
                                    [options]="supplierFilterOptions$ | async | notNull"
                                    formControlName="sellerKeys"
                                    [name]="'sellerKeys'"
                                    [group]="sellersFormGroup"
                                    [selectAllText]="allSuppliersI18n"
                                    [hideLabel]="true"
                                    [placeholder]="selectSupplierI18n"
                                >
                                </lsq-multi-select>
                            </div>
                            <!-- DO NOT DELETE: Temporarily hiding the export button until report data is fixed-->
                            <!-- <span class="export-button">
                                <lsq-export-button
                                    [request]="tableDataSource.request"
                                    [service]="payLaterInvoiceExportService"
                                    [reportName]="reportName"
                                    [isIcon]="true"
                                    [disabled]="(allSelectableInvoices$ | async)?.length == 0"
                                >
                                </lsq-export-button>
                            </span> -->
                        </div>
                        <div card-body>
                            <lsq-data-table
                                [hasHeader]="true"
                                [dataSource]="tableDataSource"
                                [isPaginated]="true"
                                [trackBy]="trackByInvoiceKey"
                                [appearance]="tableAppearance.Default"
                                [getRowClassName]="getRowClassNameBound"
                            >
                                <lsq-checkbox-column
                                    [column]="{
                                        key: rowPrimaryKey,
                                        width: '1rem',
                                        sortable: false
                                    }"
                                    [checkableRowsService]="checkableRowsService"
                                    [disableRow]="rowIsUncheckableBound"
                                    [hideSelectAll]="true"
                                >
                                </lsq-checkbox-column>
                                <lsq-column
                                    [column]="{
                                        key: 'isGroup',
                                        sortable: false
                                    }"
                                >
                                    <ng-template [custom-cell] let-row="row" let-index="index">
                                        <div
                                            [class.counter]="
                                                row.refGroupedInvoiceKey && !row.isGroup
                                            "
                                            [style.padding-top]="row.isGroup ? 0 : undefined"
                                            [style.padding-bottom]="row.isGroup ? 0 : undefined"
                                        >
                                            <ng-container *ngIf="row.isGroup">
                                                <div
                                                    class="invoice-group-expand-button"
                                                    [class.disabled]="
                                                        invoiceGroupTogglesAreDisabled
                                                    "
                                                    [attr.tabindex]="0"
                                                    (click)="handleInvoiceGroupToggleClick(row)"
                                                >
                                                    <lsq-icon
                                                        [type]="
                                                            expandedGroupInvoiceKeys.has(
                                                                row.refInvoiceKey
                                                            )
                                                                ? icons.ChevronDown
                                                                : icons.ChevronRight
                                                        "
                                                        [color]="color.Black"
                                                    >
                                                    </lsq-icon>
                                                </div>
                                            </ng-container>
                                            <ng-container *ngIf="row.refGroupedInvoiceKey">
                                                {{
                                                    row
                                                        | getOffsetIndexOfSiblingRow
                                                            : index
                                                            : 'refInvoiceKey'
                                                            : 'isGroup'
                                                        | async
                                                }}
                                            </ng-container>
                                        </div>
                                    </ng-template>
                                </lsq-column>
                                <lsq-column
                                    [column]="{
                                        header: supplierNameI18n,
                                        key: 'sellerName',
                                        truncateTextCss: true,
                                        sortable: true
                                    }"
                                >
                                </lsq-column>
                                <lsq-column
                                    [column]="{
                                        header: invoiceNumberI18n,
                                        key: 'invoiceNumber',
                                        truncateAfter: $any(invoiceNumberTruncateAfter$ | async),
                                        reverseTruncate: true,
                                        onCellClick: openInvoiceDetailsBound,
                                        isClickableFunction: isInvoiceClickableBound,
                                        sortable: true
                                    }"
                                >
                                </lsq-column>
                                <lsq-date-column
                                    [displayNullIfFieldIsTrue]="'isGroup'"
                                    [isShortDate]="true"
                                    [column]="{
                                        header: invoiceDateI18n,
                                        key: 'invoiceDate',
                                        sortable: true
                                    }"
                                >
                                </lsq-date-column>
                                <lsq-date-column
                                    [isShortDate]="true"
                                    [column]="{
                                        header: dueDateI18n,
                                        key: 'invoiceDueDate',
                                        sortable: true
                                    }"
                                >
                                </lsq-date-column>
                                <lsq-column
                                    [column]="{
                                        header: dueInI18n,
                                        key: 'dueIn',
                                        truncateTextCss: true,
                                        sortable: true
                                    }"
                                >
                                    <ng-template [custom-cell] let-row="row" let-index="index">
                                        {{ getDueIn(row.dueIn) }}
                                    </ng-template>
                                </lsq-column>
                                <lsq-currency-column
                                    [column]="{
                                        header: invoiceAmountI18n,
                                        key: 'invoiceAmount',
                                        sortable: true
                                    }"
                                >
                                </lsq-currency-column>
                                <lsq-column
                                    [column]="{
                                        header: payLaterTermI18n,
                                        key: 'termsExtensionDays',
                                        truncateTextCss: true,
                                        sortable: true
                                    }"
                                >
                                    <ng-template [custom-cell] let-row="row" let-index="index">
                                        {{ getValue(row.termsExtensionDays) }}
                                    </ng-template>
                                </lsq-column>
                                <lsq-date-column
                                    [isShortDate]="true"
                                    [column]="{
                                        header: newDueDateI18n,
                                        key: 'estimatedPayLaterDueDate',
                                        sortable: true
                                    }"
                                >
                                </lsq-date-column>
                            </lsq-data-table>
                        </div>
                    </card>
                </div>
            </div>

            <ng-container *ngIf="responsiveService.mdBelow | async">
                <div class="checkbox-controls">
                    <lsq-table-checkbox-controls
                        [isFilteredSelectAll]="true"
                        [checkableRowsService]="checkableRowsService"
                        [disabled]="!(editInvoicesClaimIsOn$ | async)"
                    ></lsq-table-checkbox-controls>
                </div>
                <div class="invoice-number-search" [formGroup]="searchInvoicesFormGroup">
                    <lsq-input
                        #invoiceNumberSearch
                        i18n-placeholder
                        placeholder="Search"
                        formControlName="invoiceNumberSearch"
                        [name]="'invoiceNumberSearch'"
                        [prependIcon]="[icons.FaMagnifyingGlassSolid, color.GraphicGray]"
                        [group]="searchInvoicesFormGroup"
                    >
                    </lsq-input>
                </div>
                <!-- FIXME: Date select not behaving correctly on mobile -->
                <!-- <div class="payment-date" [formGroup]="dateFilterFormGroup">
                    <lsq-date-select
                        id="dateFilter"
                        [allowFuture]="true"
                        [type]="datePickerType.Range"
                        [sideBySide]="true"
                        [group]="dateFilterFormGroup"
                        formControlName="dateFilter"
                        [label]="dateSelectLabel"
                    >
                    </lsq-date-select>
                </div> -->
                <div class="invoice-seller-keys" [formGroup]="sellersFormGroup">
                    <lsq-multi-select
                        *ngIf="supplierFilterOptions$ | async"
                        class="invoices-filters-suppliers-filter"
                        [options]="supplierFilterOptions$ | async | notNull"
                        formControlName="sellerKeys"
                        [name]="'sellerKeys'"
                        [group]="sellersFormGroup"
                        [selectAllText]="allSuppliersI18n"
                        [hideLabel]="true"
                        [placeholder]="selectSupplierI18n"
                    >
                    </lsq-multi-select>
                </div>

                <lsq-data-table-mobile
                    [dataSource]="tableDataSource"
                    [isPaginated]="true"
                    [cardsAreExpandable]="true"
                >
                    <ng-template #mobileCardHeader let-row="row">
                        <div class="mtc-header-wrapper">
                            <div class="mtc-checkbox">
                                <lsq-checkbox
                                    [ngModel]="
                                        checkableRowsService.isRowChecked(row[rowPrimaryKey])
                                    "
                                    (ngModelChange)="toggleCheckbox(row)"
                                    (click)="stopPropagation($event)"
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="rowIsUncheckable(row)"
                                >
                                </lsq-checkbox>
                            </div>
                            <div class="mtc-header-content">
                                <div class="invoice-list-mobile-card-header">
                                    <div class="mtc-header-content-left">
                                        <div class="mtc-header-title">
                                            {{ invoiceNumberLabel }}&nbsp;{{
                                                row.invoiceNumber
                                                    | truncateText
                                                        : (invoiceNumberTruncateAfter$
                                                              | async
                                                              | notNull)
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <ng-template #mobileCardColumns let-row="row">
                        <div class="card-item">
                            <div class="card-item-label">
                                {{ supplierNameI18n }}
                            </div>
                            <div class="card-item-value">
                                {{ row.sellerName }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ invoiceDateI18n }}
                            </div>
                            <div class="card-item-value">
                                {{ row.invoiceDate | lsqDate: 'shortDate' }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ dueDateI18n }}
                            </div>
                            <div class="card-item-value">
                                {{ row.invoiceDueDate | lsqDate: 'shortDate' }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ dueInI18n }}
                            </div>
                            <div class="card-item-value">
                                {{ getDueIn(row.dueIn) }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ invoiceAmountI18n }}
                            </div>
                            <div class="card-item-value">
                                {{ row.invoiceAmount | currencyDash }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ payLaterTermI18n }}
                            </div>
                            <div class="card-item-value">
                                {{ row.termsExtensionDays }}
                            </div>
                        </div>

                        <div class="card-item">
                            <div class="card-item-label">
                                {{ newDueDateI18n }}
                            </div>
                            <div class="card-item-value">
                                {{ row.estimatedPayLaterDueDate | lsqDate: 'shortDate' }}
                            </div>
                        </div>
                    </ng-template>
                </lsq-data-table-mobile>
            </ng-container>
        </ng-container>
    </div>
</div>
